import { TAX_TYPE_PERCENTAGE } from "./taxes";

export default [
  {
    name: "TPS",
    type: TAX_TYPE_PERCENTAGE,
    value: 5,
  },
  {
    name: "TVQ",
    type: TAX_TYPE_PERCENTAGE,
    value: 9.975,
  },
];
